export default {
  table: {
    menuName: "Menu Name",
    path: "Route Path",
    componentPath: "Component Path",
    interfacePath: "API Interface",
    hidden: "Visibility Status",
    show: "Show",
    hide: "Hide",
    type: "Type",
    catalogue: "Catalogue",
    menu: "Menu",
    btn: "Button",
    isLogRecord: "Log Record",
  },
  dialog: {
    parent: "Parent Menu",
    redirect: "Redirect",
    icon: "Icon",
    role: "Role",
    menuInternationalization: "Menu Internationalization",
    logRecord: "Log Record",
  },
};
